import {
  formatEnvironmentalHealthLabel,
  formatFactorList,
  formatRiskLevel,
  formatRiskScore,
} from "../../../utils/environmentalRiskFormatting.js";
import { RISK_DISCLAIMER } from "../../../constants/environmentalRiskLayers.js";

const PropertyEnvironmentalContextCard = ({ environmentalRisk }) => {
  if (!environmentalRisk) {
    return null;
  }

  if (!environmentalRisk.available) {
    return (
      <section className="panel-card property-environmental-context">
        <p className="eyebrow">Environmental Context</p>
        <h3>Area risk signals</h3>
        <p className="muted">
          {environmentalRisk.message || "Environmental context is not available for this property."}
        </p>
      </section>
    );
  }

  const profile = environmentalRisk.profile;
  const context = environmentalRisk.context || {};
  const topFactors = formatFactorList(profile?.factors, 3);

  return (
    <section className="panel-card property-environmental-context">
      <div className="section-heading">
        <div>
          <p className="eyebrow">Environmental Context</p>
          <h3>Area risk signals</h3>
        </div>
        <span className="status-pill">
          {formatEnvironmentalHealthLabel(
            profile?.environmentalHealthScore,
            profile?.riskLevel
          )}
        </span>
      </div>
      <p className="property-environmental-context__intro muted">
        Rule-based indicators from nearby weather, hydrology, and alert data — not official safety
        ratings.
      </p>
      <dl className="forecast-cards__grid">
        <div className="forecast-cards__card">
          <dt>Overall score</dt>
          <dd>{formatRiskScore(profile?.environmentalHealthScore)}</dd>
        </div>
        <div className="forecast-cards__card">
          <dt>Flood risk</dt>
          <dd>{formatRiskScore(profile?.floodRiskScore)}</dd>
        </div>
        <div className="forecast-cards__card">
          <dt>Storm exposure</dt>
          <dd>{formatRiskScore(profile?.stormExposureScore)}</dd>
        </div>
        <div className="forecast-cards__card">
          <dt>Recent rainfall</dt>
          <dd>
            {context.recentRainfallMm != null ? `${context.recentRainfallMm} mm` : "—"}
          </dd>
        </div>
        <div className="forecast-cards__card">
          <dt>Nearest weather station</dt>
          <dd>{context.nearestWeatherStation || "—"}</dd>
        </div>
        <div className="forecast-cards__card">
          <dt>Nearest river sensor</dt>
          <dd>{context.nearestRiverSensor || "—"}</dd>
        </div>
        <div className="forecast-cards__card">
          <dt>Flood zone status</dt>
          <dd>{context.floodZoneStatus || "—"}</dd>
        </div>
        <div className="forecast-cards__card">
          <dt>Alerts nearby</dt>
          <dd>{context.activeAlertsNearby ?? 0}</dd>
        </div>
        <div className="forecast-cards__card">
          <dt>Lightning nearby</dt>
          <dd>{context.lightningNearby ?? 0}</dd>
        </div>
        <div className="forecast-cards__card">
          <dt>Air quality (AQI)</dt>
          <dd>{context.airQualityIndex != null ? Math.round(context.airQualityIndex) : "—"}</dd>
        </div>
      </dl>
      {topFactors.length > 0 ? (
        <div className="environmental-risk-factors">
          <p className="eyebrow">Top contributing factors</p>
          <ul>
            {topFactors.map((factor) => (
              <li key={factor}>{factor}</li>
            ))}
          </ul>
        </div>
      ) : null}
      <p className="weather-context-section__meta muted">{RISK_DISCLAIMER}</p>
    </section>
  );
};

export default PropertyEnvironmentalContextCard;
